/* ===============================
   GLOBAL STORE-LOCATOR JS LOGIC
   (Handles store selection & cart clearing)
   =============================== */

/* ========= GUARANTEED SINGLETON PATTERN =========== */
if (!window.__SMOKEYS_STORE_LOCATOR__) {
  window.__SMOKEYS_STORE_LOCATOR__ = true;

  // ========= CENTRALIZED STORE HOURS CONFIGURATION =========
  // IMPORTANT: Keep these values in sync with snippets/store-hours-config.liquid
  // Change ONLY close_hour - everything else calculates automatically

  var CLOSE_HOUR = 23; // 11pm in 24hr format - CHANGE THIS to update store hours
  var OPEN_HOUR = 10;  // 10am in 24hr format

  // Calculate cutoff times automatically
  var expressHour = CLOSE_HOUR - 1;    // Express: 1 hour before close
  var standardHour = CLOSE_HOUR - 1.5; // Standard: 1.5 hours before close

  // Format times for display
  function formatHour(hour) {
    var suffix = hour >= 12 ? 'pm' : 'am';
    var displayHour = hour > 12 ? hour - 12 : hour;
    return displayHour + ':00' + suffix;
  }

  function formatHourLong(hour) {
    var suffix = hour >= 12 ? 'p.m.' : 'a.m.';
    var displayHour = hour > 12 ? hour - 12 : hour;
    return displayHour + ':00 ' + suffix;
  }

  function formatHourWithMinutes(hour, minutes) {
    var suffix = hour >= 12 ? 'pm' : 'am';
    var displayHour = hour > 12 ? hour - 12 : hour;
    var mins = minutes < 10 ? '0' + minutes : minutes;
    return displayHour + ':' + mins + suffix;
  }

  window.STORE_HOURS = {
    closeTime: formatHourLong(CLOSE_HOUR),
    closeTimeShort: formatHour(CLOSE_HOUR),
    openTime: formatHourLong(OPEN_HOUR),
    openTimeShort: formatHour(OPEN_HOUR),
    expressDeliveryCutoff: formatHour(expressHour),
    standardDeliveryCutoff: formatHourWithMinutes(Math.floor(standardHour), 30), // 1.5 hours before = :30 minutes
    closeHour24: CLOSE_HOUR,
    openHour24: OPEN_HOUR
  };

  // 1. expose on window first
  window.CAPILANO_STORE = window.CAPILANO_STORE || {
  id: "3779",
  name: "Smokey's Capilano",
  address: "7223 101 Ave NW",
  city: "Edmonton",
  province: "AB",
  postalCode: "T6A 0H9",
  latitude: 53.5409312,
  longitude: -113.4396412,
  isDeliveryAvailable: false,
  deliveryRadius: 0,
  openUntil: window.STORE_HOURS.closeTime,
  phone: "+17804402912",
  license: "778064"
};

  window.STORES = window.STORES || [
  {
    id: "3782",
    name: "Smokey's Walker",
    address: "5017 22 Ave SW",
    city: "Edmonton",
    province: "AB",
    postalCode: "T6X2N4",
    latitude: 53.4137833,
    longitude: -113.4193435,
    isDeliveryAvailable: false,
    deliveryRadius: 0,
    openUntil: window.STORE_HOURS.closeTime,
    phone: "+17804400911",
    license: "781636"
  },
  {
    id: "3782",
    name: "Smokey's 1hr Delivery",
    address: "5017 22 Ave SW", // Same as Walker
    city: "Edmonton",
    province: "AB",
    postalCode: "T6X2N4",
    latitude: 53.4137833,
    longitude: -113.4193435,
    isDeliveryAvailable: true,
    deliveryRadius: 50, // 20km radius
    isVirtualStore: true, // Flag to indicate this is a virtual delivery-only store
    openUntil: window.STORE_HOURS.closeTime,
    deliveryHours: {
      start: 11, // 11 AM
      end: 23    // 11 PM
    },
    cutoffTime: 30, // must place orders 30 min before delivery window
    phone: "+17804400911"
  },
  {
    id: "3781",
    name: "Smokey's Mill Creek",
    address: "2366 23 Ave NW",
    city: "Edmonton",
    province: "AB",
    postalCode: "T6T 0R1",
    latitude: 53.45512,
    longitude: -113.37738,
    isDeliveryAvailable: false,
    deliveryRadius: 0,
    openUntil: window.STORE_HOURS.closeTime,
    phone: "+17805402280",
    license: "781797"
  },
  {
    id: "3779",
    name: "Smokey's Capilano",
    address: "7223 101 Ave NW",
    city: "Edmonton",
    province: "AB",
    postalCode: "T6A 0H9",
    latitude: 53.5409312,
    longitude: -113.4396412,
    isDeliveryAvailable: false,
    deliveryRadius: 0,
    openUntil: window.STORE_HOURS.closeTime,
    phone: "+17804402912",
    license: "778064"
  },
  {
    id: "3784",
    name: "Smokey's Beaches",
    address: "1881 Queen Street E",
    city: "Toronto",
    province: "ON",
    postalCode: "M4L1H4",
    latitude: 43.66870600000001,
    longitude: -79.3055603,
    isDeliveryAvailable: false,
    deliveryRadius: 25,
    openUntil: window.STORE_HOURS.closeTime,
    phone: "+14167924959",
    license: "CRSA1204424"
  }
];

  // 2. keep legacy identifiers for older snippets
  var CAPILANO_STORE = window.CAPILANO_STORE;
  var STORES = window.STORES;

/* Calculates tonight's closing time - uses centralized config */
function getTodayClosingTime() {
  return window.STORE_HOURS.closeTime;
}
window.getTodayClosingTime = getTodayClosingTime; // Export globally

/* 1️⃣  Add the helper function somewhere near the top */
function ensureCartHasStoreAttribute() {
  var savedStoreId = localStorage.getItem('selectedStoreId');
  if (!savedStoreId) return Promise.resolve(false);

  return fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      // Already correct => do nothing
      if (cart.attributes && cart.attributes.store_id === savedStoreId) {
        return false; // No change needed
      }

      // Get the store city
      var savedStore = STORES.find(function(s) { return s.id === savedStoreId; });
      var savedStoreCity = savedStore ? savedStore.city : ((window.themeSettings && window.themeSettings.default_city) || 'Edmonton');

      // Otherwise patch the cart attribute
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { store_id: savedStoreId, store_city: savedStoreCity } })
      }).then(function() {
        // Restored store_id on new cart
        return true; // Indicate we had to fix it
      });
    })
    .catch(function(err) {
      console.error('[Store‑Locator] Failed to restore store_id:', err);
      return false;
    });
}

/* Check if user already has a store selected */
function hasExistingStoreSelection() {
  return localStorage.getItem('selectedStoreId') !== null;
}

/* Returns current store info + delivery preference (from localStorage) */
function getCurrentStore() {
  var storeId = localStorage.getItem('selectedStoreId');
  if (!storeId) return null;
  
  var isDelivery = localStorage.getItem('deliverySelected') === 'true';
  
  // For stores that share the same ID (physical/virtual pairs), 
  // pick the one that matches the delivery preference
  var store;
  
  if (isDelivery) {
    // First try to find a virtual store with this ID
    store = STORES.find(function(s) { return s.id === storeId && (s.isVirtualStore || s.isDeliveryAvailable); });
  } else {
    // Look for non-virtual stores first
    store = STORES.find(function(s) { return s.id === storeId && !s.isVirtualStore; });
  }
  
  // If no matching store found, fall back to any store with this ID
  if (!store) {
    store = STORES.find(function(s) { return s.id === storeId; }) || CAPILANO_STORE;
  }

  return {
    store,
    isDelivery
  };
}
window.getCurrentStore = getCurrentStore; // if you need it globally

/* Opens the store locator modal (if present) */
function openStoreLocator(isAutoOpen) {
  try {
    var modal = document.getElementById('store-locator-modal');
    if (modal) {
      // Show the modal
      modal.style.display = 'flex';

      // Handle auto-open vs manual open differently
      if (isAutoOpen) {
        // Auto-opening: Add class for tracking AND lock body scroll
        modal.classList.add('auto-opened');
        document.body.classList.add('noscroll');
        if (typeof window.__lockBody === 'function') {
          window.__lockBody();
        }
      } else {
        // Manual open: Remove auto-opened class and lock body scroll
        modal.classList.remove('auto-opened');
        document.body.classList.add('noscroll');
        if (typeof window.__lockBody === 'function') {
          window.__lockBody();
        }
      }

      // Run init if available
      if (typeof window.initLocator === 'function') {
        window.initLocator();
      }
    } else {
      // fallback if snippet not found
      console.error('[Store-Locator] Modal element not found');
      window.location.href = '/';
    }
  } catch (error) {
    console.error('[Store-Locator] Error opening store locator:', error);
  }
}

// Make it globally available for other scripts
window.openStoreLocator = openStoreLocator;

// Also expose finalizeStoreSelection globally
window.finalizeStoreSelection = finalizeStoreSelection;

/* (Optional) Example for loading store-based products */
function loadProductsForStore(storeId) {
  // Loading products for store
  // Implementation depends on your inventory logic
}

/* 
  finalizeStoreSelection(storeId, mode)
  => If user is switching stores, clear the cart, then set localStorage/cookie
  => If user is staying on the same store, just set localStorage & reload
*/
function finalizeStoreSelection(storeId, mode) {
window.finalizeStoreSelection = finalizeStoreSelection; // Make globally available
  // finalizeStoreSelection called

  // The store previously chosen
  var oldStoreId = localStorage.getItem('selectedStoreId');
  var isSwitchingStores = oldStoreId && oldStoreId !== storeId;

  if (isSwitchingStores) {
    // Clear the cart first
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function() {
        // Cart cleared because user switched stores

        // Set the new store & mode in localStorage
        localStorage.setItem('selectedStoreId', storeId);
        localStorage.setItem('deliverySelected', (mode === 'delivery').toString());

        // Also set store_id cookie
        document.cookie = 'store_id=' + storeId + '; path=/; max-age=86400';

        // Dispatch an event so other scripts can react
        window.dispatchEvent(new Event('storeSelected'));
        
        // Also dispatch delivery mode changed event
        window.dispatchEvent(new CustomEvent('deliveryModeChanged', { 
          detail: { mode: mode } 
        }));

        // Close the modal if open
        var modal = document.getElementById('store-locator-modal');
        if (modal) {
          modal.style.display = 'none';
          document.body.classList.remove('noscroll');
        }

        // Get the store city
        var selectedStore = STORES.find(function(s) { return s.id === storeId; });
        var storeCity = selectedStore ? selectedStore.city : ((window.themeSettings && window.themeSettings.default_city) || 'Edmonton');
        
        // Return the promise from cart/update so we can chain the .then()
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              store_id: storeId,
              store_city: storeCity
            }
          })
        });
      })
      .then(function() {
        // Only reload once the attribute is definitely updated
        setTimeout(function() {
          location.reload();
        }, 100);
      })
      .catch(function(error) {
        console.error('Error clearing cart or updating store_id:', error);
        // Even if it fails, reload so user isn't stuck
        setTimeout(function() {
          location.reload();
        }, 100);
      });

  } else {
    // Same store or no old store => no need to clear cart
    localStorage.setItem('selectedStoreId', storeId);
    localStorage.setItem('deliverySelected', (mode === 'delivery').toString());

    // Also set store_id cookie
    document.cookie = 'store_id=' + storeId + '; path=/; max-age=86400';

    // Dispatch an event so other scripts can react
    window.dispatchEvent(new Event('storeSelected'));
    
    // Also dispatch delivery mode changed event
    window.dispatchEvent(new CustomEvent('deliveryModeChanged', { 
      detail: { mode: mode } 
    }));

    // Close the modal if open
    var modal = document.getElementById('store-locator-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.classList.remove('noscroll');
    }

    // Get the store city
    var selectedStore = STORES.find(function(s) { return s.id === storeId; });
    var storeCity = selectedStore ? selectedStore.city : ((window.themeSettings && window.themeSettings.default_city) || 'Edmonton');
    
    // Update cart attribute => store_id and store_city
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          store_id: storeId,
          store_city: storeCity
        }
      })
    })
      .then(function() {
        // Reload once everything is finished
        setTimeout(function() {
          location.reload();
        }, 100);
      })
      .catch(function(error) {
        console.error('Error updating store_id attribute:', error);
        // Even if it fails, reload so user isn't stuck
        setTimeout(function() {
          location.reload();
        }, 100);
      });
  }
}

/* 
  On page load => if no store chosen, auto-open the modal 
  so user must pick a store first
*/
document.addEventListener('DOMContentLoaded', function() {
  // Checking store selection on DOM load

  // Check if age gate exists on the page
  var ageGateExists = document.getElementById('age-gate-modal') !== null;

  if (ageGateExists) {
    // Check if user has verified age
    var ageVerified = localStorage.getItem('smokeys_age_verified') === 'true' ||
                        document.cookie.includes('smokeys_age_verified=true');

    if (!ageVerified) {
      // Waiting for age verification first

      // Set up one-time listener for age verification
      var ageVerifiedHandler = function() {
        window.removeEventListener('ageVerified', ageVerifiedHandler);
        if (!hasExistingStoreSelection()) {
          // Small delay to ensure age gate is fully closed
          setTimeout(function() { openStoreLocator(true); }, 300);
        }
      };

      window.addEventListener('ageVerified', ageVerifiedHandler);

      // Fallback: If age gate doesn't trigger within 10 seconds, proceed anyway
      setTimeout(function() {
        window.removeEventListener('ageVerified', ageVerifiedHandler);
        var ageModal = document.getElementById('age-gate-modal');
        if (!hasExistingStoreSelection() && (!ageModal || ageModal.style.display !== 'flex')) {
          // Age gate timeout - proceeding with store selection
          openStoreLocator(true);
        }
      }, 10000);

      return;
    }
  }

  // If no age gate or already verified, proceed normally
  if (!hasExistingStoreSelection()) {
    openStoreLocator(true);
    return;
  }

  // Otherwise, silently fix the new cart if needed
  ensureCartHasStoreAttribute().then(function(didFix) {
    if (didFix) {
      // Reload so subsequent actions see the updated store_id
      location.reload();
    } else {
      // Cart was already correct, no reload needed
    }
  });
});

} // End of singleton pattern
